export const INSPECTION_EVOLUTION_COMPLETED_SERIES_NAME = 'Completed';
export const INSPECTION_EVOLUTION_SCORE_SERIES_NAME = 'Score';
